import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { ProgressBar } from "primereact/progressbar";
import { Form, Field } from "react-final-form";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";
import { classNames } from "primereact/utils";
import { addLocale } from "primereact/api";
import axios from "axios";

const BanktransactionShowComponent = (props) => {
  const { t } = props;
  const history = useHistory();
  const { entity, id } = useParams();

  const [loading, setLoading] = useState(false);

  const [displayData, setDisplayData] = useState({
    bank_account_name: "",
    amount_display: "",
    currency_display: "",
    booking_date_display: "",
    value_date_display: "",
    comment_display: "",
    type_current_display: "",
    partner_current_display: "",
  });

  const [editData, setEditData] = useState({
    partner: null,
    type: null,
  });

  const [partners, setPartners] = useState([]);
  const [partnerDisplayValue, setPartnerDisplayValue] = useState("");
  const [typeOptions, setTypeOptions] = useState([]);
  const [typeDict, setTypeDict] = useState({});
  const [transactionData, setTransactionData] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);


  addLocale("hu", {
    firstDayOfWeek: 1,
    dayNames: [
      "vasárnap",
      "hétfő",
      "kedd",
      "szerda",
      "csütörtök",
      "péntek",
      "szombat",
    ],
    dayNamesShort: ["vas", "hé", "ke", "sze", "csü", "pé", "szo"],
    dayNamesMin: ["V", "H", "K", "SZ", "CS", "P", "SZ"],
    monthNames: [
      "január",
      "február",
      "március",
      "április",
      "május",
      "június",
      "július",
      "augusztus",
      "szeptember",
      "október",
      "november",
      "december",
    ],
    monthNamesShort: [
      "jan",
      "feb",
      "mar",
      "ápr",
      "máj",
      "jun",
      "júl",
      "aug",
      "szep",
      "okt",
      "nov",
      "dec",
    ],
    today: "Ma",
    clear: "Töröl",
  });

  const apiCall = (method, url, data) => {
    return axios({
      method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("userToken"),
        "App-Network": localStorage.getItem("networkId"),
      },
    });
  };

  const searchPartner = (event) => {
    setLoading(true);
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/partner?" +
          JSON.stringify({ filters: { name: { value: event.query } } }),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "App-Network": localStorage.getItem("networkId"),
          },
        }
      )
      .then((response) => {
        const arr = [];
        if (response.data.items && response.data.items.length > 0) {
          response.data.items.forEach((p) => {
            arr.push({
              ...p,
              name:
                p.name +
                " (" +
                p.addressPostalCode +
                " " +
                p.addressCity +
                ", " +
                p.addressDetail +
                ")",
            });
          });
          setPartners(arr);
        } else {
          window.App.toastShow(
            "warn",
            "Figyelem!",
            "Nem található partner a megadott adatokkal."
          );
        }
      })
      .catch((error) => {
        window.App.toastShow(
          "error",
          t("error"),
          error.toString(),
          "",
          error.response
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const validate = () => {
    return {};
  };

  const onSubmit = () => {
    setLoading(true);

    const patchBody = {};
    if (editData.partner !== undefined) {
      patchBody.partner = editData.partner;
    }
    if (
      editData.type !== undefined &&
      editData.type !== null &&
      editData.type !== ""
    ) {
      patchBody.type = editData.type;
    }

    apiCall(
      "patch",
      "/api/v2/bank_transaction/" +
        (window.App.urlVars().BanktransactionId ?? id),
      patchBody
    )
      .then(() => {
        window.App.toastShow("success", "Sikeres mentés!");
        window.App.setState({ rerenderBanktransactionList: Math.random() });

        if (props.goback === true) {
          history.push(props.backlink);
        } else {
          setReloadKey(Math.random());
        }
      })
      .catch((error) => {
        window.App.toastShow(
          "error",
          t("error"),
          error.toString(),
          "",
          error.response
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    apiCall("get", "/api/v2/dictionary/bank-transaction-type")
      .then((res) => {
        console.log("DICT", res.data);
        const dictArr = res?.data?.data || [];

        const opts = dictArr.map((item) => ({
          label: item.value,
          value: item.key,
        }));
        setTypeOptions(opts);

        const dmap = {};
        dictArr.forEach((item) => {
          if (item && item.key !== undefined) {
            dmap[item.key] = item.value;
          }
        });
        setTypeDict(dmap);
      })
      .catch(() => {
        setTypeOptions([]);
        setTypeDict({});
      });

    if (
      (!window.App.urlVars().create &&
        window.App.urlVars().BanktransactionId) ||
      (entity === "bank-transaction" && id)
    ) {
      setLoading(true);
      apiCall(
        "get",
        "/api/v2/bank_transaction/" +
          (window.App.urlVars().BanktransactionId ?? id)
      )
        .then((response) => {
          const data = response.data.data || {};
          setTransactionData(data);
          const num = Number(data.amount);
          const formattedAmount =
            data.amount === null || data.amount === undefined || Number.isNaN(num)
              ? ""
              : window.App.currencyFormatter(data.currency, num);
          const bookingDateDisplay = data.booking_date
            ? window.App.formatDateValue(data.booking_date)
            : "";

          const valueDateDisplay = data.value_date
            ? window.App.formatDateValue(data.value_date)
            : "";

          const partnerNameCurrent = data?.partner?.name || "";

          let typeCurrentDisplay = "";
          if (!data.type && data.type_hint) {
            typeCurrentDisplay = data.type_hint;
          } else if (data.type) {
            typeCurrentDisplay = typeDict[data.type] || data.type;
          }

          setDisplayData({
            bank_account_name: data?.bank_account?.name || "",
            amount_display: formattedAmount,
            currency_display: data.currency || "",
            booking_date_display: bookingDateDisplay,
            value_date_display: valueDateDisplay,
            comment_display: data?.comment || "",
            type_current_display: "",
            partner_current_display: partnerNameCurrent,
          });

          setPartnerDisplayValue(partnerNameCurrent);
          setEditData({
            partner: data.partner?.id ?? null,
            type: data.type ?? null,
          });
        })
        .catch((error) => {
          window.App.toastShow(
            "error",
            t("error"),
            error.toString(),
            "",
            error.response
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [entity, id, t, reloadKey]);

  useEffect(() => {
    const urlVars = window.App.urlVars();
    if (urlVars.partnerName) {
      const decodedName = decodeURIComponent(urlVars.partnerName);

      setPartnerDisplayValue(decodedName);

      setEditData((prev) => ({
        ...prev,
        partner: urlVars.partnerId,
      }));
    }
  }, [window.App.urlVars().partnerName]);

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return (
      isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
    );
  };

  return (
    <div className={"project-form widget"}>
      {loading && (
        <ProgressBar
          mode="indeterminate"
          style={{
            height: "5px",
            position: "absolute",
            top: 0,
            left: 0,
            borderRadius: 0,
          }}
        />
      )}

      <div className="p-grid">
        <div className="p-col-12 p-lg-6">
          <div className="p-grid">
            <div className="p-col-12 p-lg-6">
              <div className="p-field p-fluid">
                <label>{t('columnBankAccount')}</label>
                <span className="p-d-block fake-input">
                  {displayData.bank_account_name || "—"}
                </span>
              </div>
            </div>
            <div className="p-col-12 p-lg-6">
              <div className="p-field p-fluid">
                <label>{t('columnMessage')}</label>
                <span className="p-d-block fake-input">
                  {displayData.comment_display || "—"}
                </span>
              </div>
            </div>
            <div className="p-col-12 p-lg-6">
              <div className="p-field p-fluid">
                <label>{t('columnAmount')}</label>
                <span className="p-d-block fake-input">
                  {displayData.amount_display || ""}
                </span>
              </div>
            </div>
            <div className="p-col-12 p-lg-6">
              <div className="p-field p-fluid">
                <label>{t('columnCurrency')}</label>
                <span className="p-d-block fake-input">
                  {displayData.currency_display || "—"}
                </span>
              </div>
            </div>
            <div className="p-col-12 p-lg-6">
              <div className="p-field p-fluid">
                <label>{t('columnPosted')}</label>
                <span className="p-d-block fake-input">
                  {displayData.booking_date_display || "—"}
                </span>
              </div>
            </div>
            <div className="p-col-12 p-lg-6">
              <div className="p-field p-fluid">
                <label>{t('columnValueDate')}</label>
                <span className="p-d-block fake-input">
                  {displayData.value_date_display || "—"}
                </span>
              </div>
            </div>
            <div className="p-col-12 p-lg-6">
              <div className="p-field p-fluid">
                <label>{t('currentType')}</label>
                <span className="p-d-block fake-input">
                  {(() => {
                    if (!transactionData) {
                      return "—";
                    }
                    if (!transactionData.type && transactionData.type_hint) {
                      return (
                        <span className="text-muted">
                          {transactionData.type_hint}
                        </span>
                      );
                    }
                    if (transactionData.type) {
                      return (
                        typeDict[transactionData.type] || transactionData.type
                      );
                    }

                    return "—";
                  })()}
                </span>
              </div>
            </div>
            <div className="p-col-12 p-lg-6">
              <div className="p-field p-fluid">
                <label>{t('currentPartner')}</label>
                <span className="p-d-block fake-input">
                  {displayData.partner_current_display ? (
                    displayData.partner_current_display
                  ) : (
                    <i className="pi pi-times text-danger"></i>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          className="p-col-12 p-lg-6"
          style={{
            paddingLeft: "2rem",
            marginTop: "0.5rem",
          }}
        >
          <Form
            onSubmit={onSubmit}
            initialValues={{}}
            validate={validate}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <div
                  className="p-grid p-justify-start"
                  style={{ rowGap: "1rem" }}
                >
                  <div className="p-col-12 p-lg-6">
                    <Field
                      name="partner"
                      render={({ meta }) => (
                        <div className="p-field p-fluid">
                          <label
                            htmlFor="partner"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                            style={{ fontWeight: 600 }}
                          >
                            {t('newPartner')}
                          </label>

                          <span className="p-inputgroup">
                            <Button
                              type="button"
                              className="p-button"
                              onClick={() => {
                                let _params = "?";
                                Object.entries(window.App.urlVars()).forEach(
                                  ([key, value]) => {
                                    _params += key + "=" + value + "&";
                                  }
                                );
                                _params += "search=partner";
                                history.push(
                                  window.location.hash.replace("#", "") +
                                    _params
                                );
                              }}
                            >
                              <i className="pi pi-search"></i>
                            </Button>

                            <AutoComplete
                              id="partner"
                              value={partnerDisplayValue}
                              suggestions={partners}
                              completeMethod={searchPartner}
                              field={"name"}
                              delay={1000}
                              forceSelection
                              placeholder={t('typeToSearchPlaceholder')}
                              className={classNames({
                                "p-invalid": isFormFieldValid(meta),
                              })}
                              // dropdown
                              onSelect={(e) => {
                                setPartnerDisplayValue(e.value.name);
                                setEditData({
                                  ...editData,
                                  partner: e.value.id,
                                });
                              }}
                              onChange={(e) => {
                                setPartnerDisplayValue(e.value);
                                setEditData({
                                  ...editData,
                                  partner: null,
                                });
                              }}
                              onClear={() => {
                                setPartnerDisplayValue("");
                                setEditData({
                                  ...editData,
                                  partner: null,
                                });
                              }}
                            />
                          </span>

                          {getFormErrorMessage(meta)}
                        </div>
                      )}
                    />
                  </div>

                  <div className="p-col-12 p-lg-6">
                    <Field
                      name="type"
                      render={({ meta }) => (
                        <div className="p-field p-fluid">
                          <label
                            htmlFor="type"
                            className={classNames({
                              "p-error": isFormFieldValid(meta),
                            })}
                            style={{ fontWeight: 600 }}
                          >
                            {t('newType')}
                          </label>

                          <Dropdown
                            id="type"
                            options={typeOptions}
                            optionLabel="label"
                            optionValue="value"
                            value={editData.type || null}
                            placeholder={t('selectTypePlaceholder')}onChange={(e) => {
                              setEditData({
                                ...editData,
                                type: e.value,
                              });
                            }}
                            appendTo={document.body}
                            className={classNames({
                              "p-invalid": isFormFieldValid(meta),
                            })}
                            style={{ width: "100%" }}
                          />

                          {getFormErrorMessage(meta)}
                        </div>
                      )}
                    />
                  </div>
                  <div className="p-col-12 p-lg-6">
                    {entity === "bank-transaction" && (
                      <Button
                        type="submit"
                        label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success"
                      />
                    )}
                  </div>
                </div>
              </form>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default withTranslation("common")(BanktransactionShowComponent);
